import React from 'react'
import styled from 'styled-components'
import * as microsoftTeams from '@microsoft/teams-js';

import { LoginButton } from 'app/components/Button'
import { buttonPngWidth, buttonPngHeight, buttonGoogleWidth, buttonGoogleHeight } from 'app/components/Panel'

import { config } from '../api/public'

export const PngImage = styled.img`
  width: ${buttonPngWidth};
  height: ${buttonPngHeight};
  border: 0.1rem solid #828282;
  object-fit: cover;
`
export const GoogleImage = styled.img`
  width: ${buttonGoogleWidth};
  height: ${buttonGoogleHeight};
`
export const OktaBtn = styled(LoginButton)`
  width: ${buttonPngWidth};
  background-color: #fff;
  color: #424d61;
  text-transform: none;
  display: block;
  border: 0.1rem solid #828282 !important;
  border-radius:0;
  // margin: 0 auto;
  box-shadow: 0.2rem 0.2rem 0.12rem 0 #f6f6f6;
`

export const GoogleBtn = (props) => {
  const { type } = props

  const handleGoogleOAuth = async () => {
    const central_host = await config('central_hostname')
    const api_host =
      process.env.NODE_ENV === 'production'
        ? window.location.host
        : central_host
    const login_url = `https://${api_host}/reception/google/start`
    window.location = login_url
  }
  const Google_Login = `${process.env.PUBLIC_URL}/web_light_sq_SI.svg`
  return (
    <LoginButton key={type} type={type} onClick={handleGoogleOAuth} primary>
      <GoogleImage src={Google_Login} alt='Google logo' />
    </LoginButton>
  )
}

export const MSBtn = (props) => {
  const { type } = props

  const handleMicrosoftOAuth = async () => {
    const central_host = await config('central_hostname')
    const api_host =
      process.env.NODE_ENV === 'production'
        ? window.location.host
        : central_host
    const login_url = `https://${api_host}/reception/microsoft/start`
    const popupWidth = 600
    const popupHeight = 535
    if (window.microsoftTeams) {
      microsoftTeams.initialize();
      microsoftTeams.authentication.authenticate({
        url: login_url,
        width: popupWidth,
        height: popupHeight,
        successCallback: (result) => {
          console.log('Authentication succeeded', result);
        },
        failureCallback: (error) => {
          console.error('Authentication failed', error);
        }
      });
    } else {
      window.location = login_url;
    }
  }
  const MS_Login = `${process.env.PUBLIC_URL}/ms-symbollockup_signin_light.svg`

  return (
    <LoginButton key={type} onClick={() => handleMicrosoftOAuth()}>
      <img src={MS_Login} alt='Microsoft OAuth Logo' />
    </LoginButton>
  )
}

export const OPENIDBtn = (props) => {
  const { realmInfo, type, tenantUuid } = props
  const handleOpenIdOAuth = async () => {
    const realmAddress = realmInfo.address
    const login_url = `${realmAddress}/concierge/auth/openid/start/${tenantUuid}`
    window.location = login_url
  }
  const openId_Login = `${process.env.PUBLIC_URL}/open_id.png`
  return (
    <LoginButton key={type} onClick={handleOpenIdOAuth} primary>
      <PngImage src={openId_Login} alt='OpenId logo' />
    </LoginButton>
  )
}

export const OKTABtn = (props) => {
  const { realmInfo, type, tenantUuid } = props
  const handleOktaOAuth = async () => {
    const realmAddress = realmInfo.address
    const login_url = `${realmAddress}/concierge/auth/okta/start/${tenantUuid}`
    window.location = login_url
  }

  return (
    <OktaBtn key={type} onClick={handleOktaOAuth} primary>
      Sign in with Okta
    </OktaBtn>
  )
}
